import { LICENSE_INFO } from '@core/models'

import { LICENSE_ICON_SIZES } from '../../constants/licenseIconSizes'

import { AudioLicense } from './AudioLicense'
import type { TAudioLicenseSectionProps } from './AudioLicense.types'

export const AudioLicenseFallback = ({ license, learnMoreLabel }: TAudioLicenseSectionProps) => {
    const { title, description, link } = LICENSE_INFO[license]
    const { width, height } = LICENSE_ICON_SIZES[license]

    return (
        <AudioLicense
            icon={<svg width={width} height={height} aria-hidden="true" />}
            title={title}
            description={description}
            learnMoreLabel={learnMoreLabel}
            learnMoreHref={link}
        />
    )
}
